import React, { Component } from 'react';
import { Card, Tabs, Table, Select, Button, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TabPane } = Tabs;
const { Option } = Select;

class TodoListModule extends Component {
    state = {
        loading: false,
        tabType: 'CRC',
        dataSource: [],
        pagination: { current: 1, pageSize: 10, total: 0 },
        projectList: [],
        siteList: [],
        selectedProject: undefined,
        selectedSite: undefined,
        filterNo: '',
    };

    componentDidMount() {
        if (this.props.selectedDate) {
            this.loadProjectList();
            this.loadTodoList();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedDate !== this.props.selectedDate) {
            this.setState({
                pagination: { current: 1, pageSize: 10, total: 0 },
                selectedProject: undefined,
                selectedSite: undefined,
                filterNo: '',
            });
            this.loadProjectList();
            this.loadTodoList();
        }
        if (prevState.tabType !== this.state.tabType) {
            this.setState({
                pagination: { current: 1, pageSize: 10, total: 0 },
                selectedProject: undefined,
                selectedSite: undefined,
                filterNo: '',
            });
            this.loadProjectList();
            this.loadTodoList();
        }
    }

    loadProjectList = () => {
        const { selectedDate } = this.props;
        if (!selectedDate) return;
        const { userId } = sessionStorage;
        const { tabType } = this.state;

        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.queryUserProjects,
            data: { curUserId: userId, date: selectedDate, tabType },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success) {
                    this.setState({ projectList: res.data || [], siteList: [] });
                }
            },
        };
        $.sendRequest(options);
    };

    loadSiteList = (projectShortName) => {
        const { selectedDate } = this.props;
        if (!selectedDate || !projectShortName) {
            this.setState({ siteList: [], selectedSite: undefined });
            return;
        }
        const { userId } = sessionStorage;
        const { tabType } = this.state;

        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.queryUserSites,
            data: { curUserId: userId, date: selectedDate, tabType, projectShortName },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success) {
                    this.setState({ siteList: res.data || [], selectedSite: undefined });
                }
            },
        };
        $.sendRequest(options);
    };

    loadTodoList = () => {
        const { selectedDate } = this.props;
        if (!selectedDate) return;

        this.setState({ loading: true });
        const { userId } = sessionStorage;
        const { tabType, selectedProject, selectedSite, filterNo } = this.state;

        const data = {
            curUserId: userId,
            date: selectedDate,
            tabType,
        };
        if (selectedProject) data.projectShortName = selectedProject;
        if (selectedSite) data.siteName = selectedSite;
        if (filterNo) data.filterNo = filterNo;

        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.queryTodoList,
            data,
            dataType: 'json',
            doneResult: (res) => {
                if (res.success && res.data) {
                    const list = res.data.list || [];
                    this.setState({
                        dataSource: list,
                        pagination: { current: 1, pageSize: 10, total: list.length },
                        projectList: res.data.projectList || this.state.projectList,
                    });
                }
                this.setState({ loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    };

    handleTabChange = (key) => {
        this.setState({ tabType: key });
    };

    handleProjectChange = (value) => {
        this.setState({ selectedProject: value, selectedSite: undefined }, () => {
            if (value) {
                this.loadSiteList(value);
            } else {
                this.setState({ siteList: [] });
            }
            this.loadTodoList();
        });
    };

    handleSiteChange = (value) => {
        this.setState({ selectedSite: value }, () => {
            this.loadTodoList();
        });
    };

    handleFilterNoChange = (e) => {
        this.setState({ filterNo: e.target.value });
    };

    handleSearch = () => {
        this.loadTodoList();
    };

    handleReset = () => {
        this.setState({ selectedProject: undefined, selectedSite: undefined, filterNo: '', siteList: [] }, () => {
            this.loadTodoList();
        });
    };

    handleTableChange = (pagination) => {
        this.setState({ pagination });
    };

    handleView = (record) => {
        if (record.recordType === 'VISIT') {
            // 设置 sessionStorage，目标页面依赖这些值
            sessionStorage.invId = record.investigationId;
            sessionStorage.siteId = record.investigationSiteId;
            if (record.projectShortName) sessionStorage.invName = record.projectShortName;
            if (record.siteName) sessionStorage.investigationSiteName = record.siteName;
            window.location.href = `/#/execute/crf/Type_Visit/${record.patientUserId}`;
        } else if (record.recordType === 'SITE_START') {
            // 设置 sessionStorage，中心启动记录页面依赖这些值
            sessionStorage.invId = record.investigationId;
            sessionStorage.siteId = 0;
            sessionStorage.filterInvestigationSiteId = record.investigationSiteId;
            if (record.projectShortName) sessionStorage.invName = record.projectShortName;
            if (record.siteName) sessionStorage.investigationSiteName = record.siteName;
            window.location.href = `/#/startUp/siteStart`;
        }
    };

    getColumns = () => [
        {
            title: '项目简称',
            dataIndex: 'projectShortName',
            key: 'projectShortName',
            width: 150,
        },
        {
            title: '中心名称',
            dataIndex: 'siteName',
            key: 'siteName',
            width: 200,
        },
        {
            title: '筛选编号',
            dataIndex: 'filterNo',
            key: 'filterNo',
            width: 120,
        },
        {
            title: '访视阶段/周期',
            dataIndex: 'visitStage',
            key: 'visitStage',
            width: 150,
        },
        {
            title: '访视次数',
            dataIndex: 'visitCount',
            key: 'visitCount',
            width: 80,
        },
        {
            title: '操作',
            key: 'action',
            width: 80,
            render: (_, record) => (
                <span className="todoList-viewBtn" onClick={() => this.handleView(record)}>查看</span>
            ),
        },
    ];

    render() {
        const { loading, tabType, dataSource, pagination, projectList, siteList,
            selectedProject, selectedSite, filterNo } = this.state;
        const { selectedDate } = this.props;

        return (
            <Card className="todoList-module" title={`${selectedDate || ''} 待办事项`}>
                <Tabs activeKey={tabType} onChange={this.handleTabChange}>
                    <TabPane tab="CRC待办" key="CRC" />
                    <TabPane tab="PM待核查" key="PM" />
                </Tabs>

                <div className="todoList-search">
                    <Select
                        placeholder="项目简称"
                        value={selectedProject}
                        onChange={this.handleProjectChange}
                        style={{ width: 180 }}
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {projectList.map((item, index) => (
                            <Option key={index} value={item} title={item}>{item}</Option>
                        ))}
                    </Select>
                    <Select
                        placeholder="中心名称"
                        value={selectedSite}
                        onChange={this.handleSiteChange}
                        style={{ width: 180, marginLeft: 8 }}
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {siteList.map((item, index) => (
                            <Option key={index} value={item} title={item}>{item}</Option>
                        ))}
                    </Select>
                    <input
                        placeholder="筛选编号"
                        value={filterNo}
                        onChange={this.handleFilterNoChange}
                        style={{ width: 120, marginLeft: 8, height: 32, padding: '4px 11px', border: '1px solid #d9d9d9', borderRadius: 4, boxSizing: 'border-box' }}
                    />
                    <Button type="primary" onClick={this.handleSearch} style={{ marginLeft: 8 }}>搜索</Button>
                    <Button onClick={this.handleReset} style={{ marginLeft: 8 }}>重置</Button>
                </div>

                <Spin spinning={loading}>
                    <Table
                        dataSource={dataSource}
                        columns={this.getColumns()}
                        rowKey={(record, index) => index}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            total: pagination.total,
                            showTotal: (total) => `共 ${total} 条`,
                            size: 'small',
                        }}
                        onChange={this.handleTableChange}
                        size="small"
                        scroll={{ x: true, y: 400 }}
                    />
                </Spin>
            </Card>
        );
    }
}

export default TodoListModule;



// WEBPACK FOOTER //
// ./src/components/homePage/monthlyPlan/TodoListModule.js